/// Placeholder state cards while the area list loads
export function StateAreasLoadingSkeleton() {
  return (
    <div className="state-areas-grid" aria-busy="true">
      <span className="cw-sr-only" role="status">Loading areas</span>
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="cw-card state-areas">
          <span className="cw-skeleton cw-skeleton--short" style={{ marginTop: 0 }} />
          {Array.from({ length: 8 }).map((_, j) => (
            <span key={j} className="cw-skeleton" style={{ width: `${50 + ((j * 17) % 30)}%` }} />
          ))}
        </div>
      ))}
    </div>
  );
}
